<template>
  <Modal class="max-w-[546px]!">
    <Modal.Body>
      <SelectPlanBillingBody :plans="plans" />
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@dacr/library'

import type { Plan } from '@/shared/graphql/legacy/generated'
import SelectPlanBillingBody from './SelectPlanBillingBody.vue'

defineProps<{
  plans: Plan[]
}>()
</script>
